// @flow

import authenticationInitialState from './Authentication/initialState';
import newsletterNotificationsInitialState from './NewsletterNotifications/initialState';
import searchNotificationsInitialState from './SearchNotifications/initialState';
import deleteSearchNotificationInitialState from './DeleteSearchNotification/initialState';
import snackbarInitialState from './Snackbar/initialState';
import loaderNotificationsInitialState from './LoaderNotifications/initialState';
import resolvedParamsInitialState from './resolvedParams/initialState';

const notificationsManagerState = {
  user: authenticationInitialState,
  newsletterNotifications: newsletterNotificationsInitialState,
  searchNotifications: searchNotificationsInitialState,
  confirmedDeletionSearchNotification: deleteSearchNotificationInitialState,
  snackbar: snackbarInitialState,
  loader: loaderNotificationsInitialState,
  resolvedParams: resolvedParamsInitialState,
};

export default notificationsManagerState;



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/initialState.js